export default {
    "zh": {
        title: '请登录MOVAhome',
        phoneEmailId: "请输入手机号/邮箱/MOVA ID",
        validPhoneEmailId: '请输入手机号/邮箱/MOVA ID',
        password: '请输入密码',
        validPassword: '请输入密码',
        codeLogin: '验证码登录',
        phoneNumber: '请输入手机号',
        validPhoneNumer: '请输入手机号',
        validCode: '请输入验证码',
        code: '请输入验证码',
        accountPasswordLogin: '账号密码登录',
        pleaseCheck: '我已同意',
        userShedule: '《用户协议》',
        and: '及',
        privary: "《隐私政策》",
        addtionnal: "",
        login: '登录',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: '小度',
        cat: '天猫精灵',
        Alice: 'Yandex Alice',
        moorgen: '摩根',
        vk:'VK',
        leelen:'立林',
        loginDescPart1: '登录即表示您授权',
        loginDescPart12: '控制您的设备',
        getCode: '获取验证码',
        alreadySend: '已发送',
        search: '搜索',
        region: '地区',
        emptyPhone: '请输入手机号',
        getCodeFirst: '请先获取验证码',
        loginTryMany: '密码输入错误次数已达上限，账号已锁定，请稍后再试',
        know: '知道了',
        chooseLang: '语言选择',
        second: 's',
        useNotFound: '用户不存在',
        phoneNotFound: '用户不存在',
        notMatch: '请确认密码输入是否正确',
        errorMuch: '请求过于频繁，请稍后重试',
        codeErr: '验证码无效或过期',
        codeSendErr: '验证码发送失败',
        codeSendFrequent: '验证码发送请求太频繁，请稍候…',
        codeSendLimit: '验证码获取次数达到上限，请两小时后重新获取',
        sendSuccess: "发送成功",
        sendFailure: "验证码发送失败",
        unregisterPhone: "账号未注册，请去MOVAhome APP中注册账号"
    },
    'en': {
        leelen:'Leelen',
        title: 'Log in to MOVAhome App',
        phoneEmailId: "Mobile number/email/MOVA ID",
        validPhoneEmailId: 'Mobile number/email/MOVA ID',
        password: 'Password',
        validPassword: 'Password',
        codeLogin: 'Log in with verification code',
        phoneNumber: 'Mobile number',
        validPhoneNumer: 'Mobile number',
        validCode: 'Verification code',
        code: 'Verification code',
        accountPasswordLogin: 'Log in with password',
        pleaseCheck: 'I have read and agreed ',
        userShedule: 'User Agreement',
        and: 'and',
        privary: "Privacy Policy.",
        addtionnal: "",
        login: 'Log In',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        moorgen: 'Moorgen',
        loginDescPart1: 'By logging in, you are authorizing',
        loginDescPart12: 'to control your devices.',
        getCode: 'Get Code',
        alreadySend: 'Resend code',
        search: 'Search',
        region: 'Region',
        emptyPhone: 'Mobile number',
        getCodeFirst: 'Please get code sent first.',
        loginTryMany: 'Too many attempts, the account has been locked. Please try again later.',
        know: 'OK',
        chooseLang: 'Languages',
        second: 's',
        useNotFound: 'The requested user does NOT exist.',
        phoneNotFound: 'The requested user does NOT exist.',
        notMatch: 'Invalid password',
        errorMuch: 'Too many attempts, please try again later.',
        codeErr: 'Verification code is invalid or expired.',
        codeSendErr: 'Failed to send you a code.',
        codeSendFrequent: 'Too many attempts, please try again later...',
        codeSendLimit: 'Exceeded number of verification code requests. Please try again in 2 hours.',
        sendSuccess: "A code has been sent to you.",
        sendFailure: "Failed to send you a code.",
        unregisterPhone: "This account does not exist. Please sign up in the MOVAhome APP.",
        vk: 'VK',
    },
    'ru': {
        leelen:'Leelen',
        moorgen: 'Moorgen',
        title: 'Войти в MOVAhome',
        phoneEmailId: "Номер телефона/эл. почта/ID MOVA",
        validPhoneEmailId: 'Номер телефона/эл. почта/ID MOVA',
        password: 'Пароль',
        validPassword: 'Пароль',
        codeLogin: 'Войти по коду подтверждения',
        phoneNumber: 'Номер телефона',
        validPhoneNumer: 'Номер телефона',
        validCode: 'Код подтверждения',
        code: 'Код подтверждения',
        accountPasswordLogin: 'Войти по паролю',
        pleaseCheck: 'Я прочитал(-а) и принимаю условия',
        userShedule: 'Пользовательского соглашения',
        addtionnal: "",
        and: 'и',
        privary: "Политики конфиденциальности.",
        login: 'Войти',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Яндекс Алиса',
        loginDescPart1: 'Выполняя вход в систему, Вы передаете',
        loginDescPart12: 'право контроля за Вашими устройствами.',
        getCode: 'Получить код',
        alreadySend: 'Повторить через',
        search: 'Поиск',
        region: 'Регион',
        emptyPhone: 'Номер телефона',
        getCodeFirst: 'Сначала получите код подтверждения.',
        loginTryMany: 'Слишком много попыток. Аккаунт был заблокирован. Повторите попытку позже.',
        know: 'OK',
        chooseLang: 'Языки',
        second: 's',
        useNotFound: 'Запрашиваемый пользователь НЕ существует.',
        phoneNotFound: 'Запрашиваемый пользователь НЕ существует.',
        notMatch: 'Недействительный пароль',
        errorMuch: 'Слишком много попыток. Повторите попытку позже.',
        codeErr: 'Срок действия кода подтверждения истек или код введен некорректно.',
        codeSendErr: 'Сбой отправки кода.',
        codeSendFrequent: 'Слишком много попыток. Повторите попытку позже...',
        codeSendLimit: 'Превышено максимальное количество запросов кода подтверждения. Повторите попытку через 2 часа.',
        sendSuccess: "Код отправлен.",
        sendFailure: "Сбой отправки кода.",
        unregisterPhone: "Такой аккаунт не существует. Зарегистрируйтесь в приложении MOVAhome.",
        vk: 'VK',
    },
    "zh-hk": {
        leelen:'Leelen',
        moorgen: 'Moorgen',
        title: '請登錄MOVAhome App',
        phoneEmailId: "請輸入手機號碼/郵箱/追覓ID",
        validPhoneEmailId: '請輸入手機號碼/郵箱/追覓ID',
        password: '請輸入密碼',
        validPassword: '請輸入密碼',
        codeLogin: '驗證碼登錄',
        phoneNumber: '請輸入手機號碼',
        validPhoneNumer: '請輸入手機號碼',
        validCode: '請輸入驗證碼',
        code: '請輸入驗證碼',
        accountPasswordLogin: '帳號密碼登錄',
        pleaseCheck: '我已同意',
        userShedule: '《用户協議》',
        addtionnal: "",
        and: '及',
        privary: "《私隱政策》",
        login: '登錄',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: '登錄即表示您授權',
        loginDescPart12: '控制您的設備',
        getCode: '獲取驗證碼',
        alreadySend: '已發送',
        search: '搜索',
        region: '地區',
        emptyPhone: '請輸入手機號碼',
        getCodeFirst: '請先獲取驗證碼',
        loginTryMany: '密碼輸入錯誤次數已達上限，帳號已鎖定，請稍後再試',
        know: '知道了',
        chooseLang: '語言選擇',
        second: 's',
        useNotFound: '用户不存在',
        phoneNotFound: '用户不存在',
        notMatch: '請確認密碼輸入是否正確',
        errorMuch: '請求過於頻繁，請稍後重試',
        codeErr: '驗證碼無效或過期',
        codeSendErr: '驗證碼發送失敗',
        codeSendFrequent: '驗證碼發送請求太頻繁，請稍候…',
        codeSendLimit: '驗證碼獲取次數達到上限，請兩小時後重新獲取',
        sendSuccess: "發送成功",
        sendFailure: "驗證碼發送失敗",
        unregisterPhone: "帳號未註冊，請去MOVAhome APP中註冊帳號",
        vk: 'VK',
    },
    "zh-tw": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: '請登入 MOVAhome App',
        phoneEmailId: "請輸入手機號碼/郵箱/追覓ID",
        validPhoneEmailId: '請輸入手機號碼/郵箱/追覓ID',
        password: '請輸入密碼',
        validPassword: '請輸入密碼',
        codeLogin: '驗證碼登入',
        phoneNumber: '請輸入手機號碼',
        validPhoneNumer: '請輸入手機號碼',
        validCode: '請輸入驗證碼',
        code: '請輸入驗證碼',
        accountPasswordLogin: '帳號密碼登入',
        pleaseCheck: '我已同意',
        userShedule: '《使用者協議》',
        and: '及',
        privary: "《隱私政策》",
        addtionnal: "",
        login: '登入',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: '登入即表示您授權',
        loginDescPart12: '控制您的裝置',
        getCode: '獲取驗證碼',
        alreadySend: '已發送',
        search: '搜尋',
        region: '地區',
        emptyPhone: '請輸入手機號碼',
        getCodeFirst: '請先獲取驗證碼',
        loginTryMany: '密碼輸入錯誤次數已達上限，帳號已鎖定，請稍後再試',
        know: '知道了',
        chooseLang: '語言選擇',
        second: 's',
        useNotFound: '使用者不存在',
        phoneNotFound: '使用者不存在',
        notMatch: '請確認密碼輸入是否正確',
        errorMuch: '請求過於頻繁，請稍後重試',
        codeErr: '驗證碼無效或過期',
        codeSendErr: '驗證碼發送失敗',
        codeSendFrequent: '請求驗證碼發送太頻繁，請稍候…',
        codeSendLimit: '驗證碼獲取次數已達到上限，請於兩小時後重新請求發送',
        sendSuccess: "發送成功",
        sendFailure: "驗證碼發送失敗",
        unregisterPhone: "帳號未註冊，請去MOVAhome APP中註冊帳號"
    },
    "de": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'Melden Sie sich bei der MOVAhome App an',
        phoneEmailId: "Handynummer/E-Mail/MOVA-ID",
        validPhoneEmailId: 'Handynummer/E-Mail/MOVA-ID',
        password: 'Passwort',
        validPassword: 'Passwort',
        codeLogin: 'Anmeldung mit Verifizierungscode',
        phoneNumber: 'Telenummer',
        validPhoneNumer: 'Telenummer',
        validCode: 'Verifizierungscode',
        code: 'Verifizierungscode',
        accountPasswordLogin: 'Login mit Passwort',
        pleaseCheck: 'Ich habe gelesen und bin damit einverstanden',
        userShedule: 'Nutzungsbedingungen ',
        and: 'und ',
        privary: "Datenschutzregelungen",
        addtionnal: "",
        login: 'Login',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Mit der Anmeldung autorisieren Sie',
        loginDescPart12: 'zur Steuerung Ihrer Geräte.',
        getCode: 'Get code',
        alreadySend: 'Senden Sie den Code',
        search: 'Suche',
        region: 'Region',
        emptyPhone: 'Telenummer',
        getCodeFirst: 'Bitte schicken Sie zuerst den Code.',
        loginTryMany: 'Zu viele Versuche, das Konto wurde gesperrt. Bitte versuchen Sie es später erneut.',
        know: 'Ok',
        chooseLang: 'Sprachen',
        second: 's',
        useNotFound: 'Der angeforderte Benutzer existiert nicht.',
        phoneNotFound: 'Der angeforderte Benutzer existiert nicht.',
        notMatch: 'Falsches Passwort',
        errorMuch: 'Zu viele Versuche, bitte versuchen Sie es später noch einmal.',
        codeErr: 'Der Verifizierungscode ist ungültig oder abgelaufen.',
        codeSendErr: 'Es konnte Ihnen kein Code gesendet werden.',
        codeSendFrequent: 'Zu viele Versuche, bitte versuchen Sie es später noch einmal...',
        codeSendLimit: 'Die maximale Anzahl an Verifizierungscode-Anfragen überschreiten. Bitte versuchen Sie es in 2 Stunden erneut.',
        sendSuccess: "Ein Code wurde an Sie gesendet.",
        sendFailure: "Es konnte Ihnen kein Code gesendet werden.",
        unregisterPhone: "Dieses Konto existiert nicht. Bitte melden Sie sich in der MOVAhome APP an."
    },
    "ko": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'MOVAhome App에 로그인',
        phoneEmailId: "핸드폰 번호/이메일주소/MOVA ID",
        validPhoneEmailId: '핸드폰 번호/이메일주소/MOVA ID',
        password: '비밀번호',
        validPassword: '비밀번호',
        codeLogin: '인증 코드로 로그인',
        phoneNumber: '핸드폰 번호',
        validPhoneNumer: '핸드폰 번호',
        validCode: '확인 코드',
        code: '확인 코드',
        accountPasswordLogin: '비밀번호로 로그인',
        pleaseCheck: '나는',
        userShedule: '사용자 계약',
        and: '및',
        privary: "개인 정보 보호 정책을",
        addtionnal: "읽고 동의했습니다.",
        login: '로그인',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: '로그인하면',
        loginDescPart12: '이 장치를 제어할 수 있습니다.',
        getCode: '코드 받기',
        alreadySend: '코드 번호 재전송',
        search: '검색',
        region: '지역',
        emptyPhone: '핸드폰 번호',
        getCodeFirst: '먼저 코드를 보내주세요.',
        loginTryMany: '시도 횟수가 너무 많습니다. 계정이 잠겼습니다. 나중에 다시 시도해 주십시오.',
        know: '승인',
        chooseLang: '언어',
        second: 's',
        useNotFound: '요청한 사용자가 존재하지 않습니다.',
        phoneNotFound: '요청한 사용자가 존재하지 않습니다.',
        notMatch: '잘못된 비밀번호',
        errorMuch: '시도 횟수가 너무 많습니다. 나중에 다시 시도해 주세요.',
        codeErr: '인증 코드가 유효하지 않거나 만료되었습니다.',
        codeSendErr: '코드 전송에 실패 했습니다.',
        codeSendFrequent: '시도 횟수가 너무 많습니다. 나중에 다시 시도해 주세요…',
        codeSendLimit: '인증 코드 요청 수를 초과했습니다. 2시간 후에 다시 시도해 주세요.',
        sendSuccess: "코드가 전송되었습니다.",
        sendFailure: "코드 전송에 실패 했습니다.",
        unregisterPhone: "이 계정은 존재하지 않습니다. MOVAhome APP에 가입해 주세요."
    },
    "ja": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'MOVAhome Appにログインしてください。',
        phoneEmailId: "携帯番号/メールアドレス/MOVA IDを入力してください",
        validPhoneEmailId: '携帯番号/メールアドレス/MOVA IDを入力してください',
        password: 'パスワードを入力してください',
        validPassword: 'パスワードを入力してください',
        codeLogin: '認証コードでログイン',
        phoneNumber: '携帯電話番号を入力してください',
        validPhoneNumer: '携帯電話番号を入力してください',
        validCode: '認証コードを入力してください',
        code: '認証コードを入力してください',
        accountPasswordLogin: 'アカウントのパスワードでログイン',
        pleaseCheck: '',
        userShedule: '「ユーザー契約」',
        and: 'および',
        privary: "「プライバシーポリシー」.",
        addtionnal: "に同意しました",
        login: 'ログイン',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'ログインすると、',
        loginDescPart12: 'にデバイスの制御を許可することとなります',
        getCode: '認証コード獲得',
        alreadySend: '前に送信しました。',
        search: '検索',
        region: 'お住まいの国や地域',
        emptyPhone: '携帯電話番号を入力してください',
        getCodeFirst: 'まず、認証コードを獲得してください',
        loginTryMany: 'パスワードの入力ミス回数が上限に達しました。アカウントはロックされています。後でやり直してください',
        know: 'はい',
        chooseLang: '言語選択',
        second: 's',
        useNotFound: 'ユーザーが存在しません。',
        phoneNotFound: 'ユーザーが存在しません。',
        notMatch: 'ご入力されたパスワードは正しいかどうかを確認してください。',
        errorMuch: '操作が頻繁に行われています。しばらくしてから、再試行してください。',
        codeErr: '認証コードは無効になっているか、期限切れになっています。',
        codeSendErr: '認証コードの送信に失敗しました',
        codeSendFrequent: '認証コードが頻繁に送信されています。少々お待ちください。',
        codeSendLimit: '認証コードの獲得回数は上限に達しました。二時間後、改めて獲得してください。',
        sendSuccess: "送信に成功しました",
        sendFailure: "認証コードの送信に失敗しました",
        unregisterPhone: "アカウントが登録されていません。MOVAhomeアプリにアカウントを登録してください"
    },
    "fr": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: `Connectez-vous à l'application MOVAhome.`,
        phoneEmailId: "Numéro de téléphone portable/email/identifiant MOVA",
        validPhoneEmailId: 'Numéro de téléphone portable/email/identifiant MOVA',
        password: 'Mot de passe',
        validPassword: 'Mot de passe',
        codeLogin: 'Connectez-vous avec un code de vérification',
        phoneNumber: 'Numéro de mobile',
        validPhoneNumer: 'Numéro de mobile',
        validCode: 'Code de vérification',
        code: 'Code de vérification',
        accountPasswordLogin: 'Se connecter avec le mot de passe',
        pleaseCheck: `J'ai lu et j'accepte`,
        userShedule: `les Conditions d'utilisation`,
        and: 'et',
        privary: "la Politique de confidentialité.",
        addtionnal: "",
        login: 'Se connecter',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'En vous connectant, vous autorisez',
        loginDescPart12: 'à contrôler vos appareils',
        getCode: 'Obtenir le code',
        alreadySend: 'Code renvoyé au',
        search: 'Rechercher',
        region: 'Région',
        emptyPhone: 'Numéro de mobile',
        getCodeFirst: `Veuillez d'abord vous faire envoyer le code`,
        loginTryMany: 'Trop de tentatives, le compte a été verrouillé. Veuillez réessayer plus tard.',
        know: 'OK',
        chooseLang: 'Langues',
        second: 's',
        useNotFound: `L'utilisateur demandé n'existe pas.`,
        phoneNotFound: `L'utilisateur demandé n'existe pas.`,
        notMatch: 'Mot de passe invalide',
        errorMuch: 'Trop de tentatives, veuillez réessayer plus tard.',
        codeErr: `Le code de vérification n'est pas valide ou a expiré.`,
        codeSendErr: `Le code n'a pas pu être envoyé.`,
        codeSendFrequent: 'Trop de tentatives, veuillez réessayer plus tard...',
        codeSendLimit: 'Le nombre maximum de demandes de code de vérification a été dépassé. Veuillez réessayer dans 2 heures.',
        sendSuccess: "Un code vous a été envoyé.",
        sendFailure: "Le code n'a pas pu être envoyé.",
        unregisterPhone: "Ce compte n'existe pas. Veuillez vous inscrire dans l'APP MOVAhome."
    },
    "es": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'Inicie sesión en MOVAhome App',
        phoneEmailId: "Número de teléfono móvil/correo electrónico/ID de MOVA",
        validPhoneEmailId: 'Número de teléfono móvil/correo electrónico/ID de MOVA',
        password: 'Contraseña',
        validPassword: 'Contraseña',
        codeLogin: 'Iniciar sesión con código de verificación',
        phoneNumber: 'Número de teléfono móvil',
        validPhoneNumer: 'Número de teléfono móvil',
        validCode: 'Código de verificación',
        code: 'Código de verificación',
        accountPasswordLogin: 'Iniciar sesión con contraseña',
        pleaseCheck: 'He leído y acepto el',
        userShedule: 'Acuerdo de Usuario',
        addtionnal: "",
        and: 'y la',
        privary: "Política de Privacidad.",
        login: 'Iniciar Sesión',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Al iniciar sesión, autoriza a',
        loginDescPart12: 'a controlar sus dispositivos',
        getCode: 'Obtener código',
        alreadySend: 'Reenviar código',
        search: 'Buscar',
        region: 'Región',
        emptyPhone: 'Número de teléfono móvil',
        getCodeFirst: 'Por favor, envíe el código primero.',
        loginTryMany: 'Demasiados intentos, la cuenta se ha bloqueado. Por favor, inténtelo de nuevo más tarde.',
        know: 'OK',
        chooseLang: 'Idiomas',
        second: 's',
        useNotFound: 'El usuario solicitado NO existe.',
        phoneNotFound: 'El usuario solicitado NO existe.',
        notMatch: 'Contraseña inválida',
        errorMuch: 'Demasiados intentos. Por favor, intente mas tarde.',
        codeErr: 'El código de verificación no es válido o ha caducado.',
        codeSendErr: 'No se pudo enviar el código.',
        codeSendFrequent: 'Demasiados intentos. Por favor, intente mas tarde...',
        codeSendLimit: 'Ha excedido el número máximo de solicitudes de códigos de verificación. Por favor, vuelva a intentarlo en 2 horas.',
        sendSuccess: "Se le ha enviado un código.",
        sendFailure: "No se pudo enviar el código.",
        unregisterPhone: "Esta cuenta no existe. Regístrese en la aplicación MOVAhome."
    },
    "it": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: "Accedi all'App MOVAhome",
        phoneEmailId: "Numero di cellulare/e-mail/ID MOVA",
        validPhoneEmailId: 'Numero di cellulare/e-mail/ID MOVA',
        password: 'Password',
        validPassword: 'Password',
        codeLogin: 'Accedi con il codice di verifica',
        phoneNumber: 'Numero di cellulare',
        validPhoneNumer: 'Numero di cellulare',
        validCode: 'Codice di verifica',
        code: 'Codice di verifica',
        accountPasswordLogin: 'Accedi con password',
        pleaseCheck: 'Ho letto e accetto',
        userShedule: "l'Accordo per gli Utenti",
        and: 'e la',
        privary: "Politica sulla Privacy.",
        addtionnal: "",
        login: 'Accedi',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: `Effettuando l'accesso, autorizzi`,
        loginDescPart12: ' a controllare i tuoi dispositivi.',
        getCode: 'Ottieni il codice',
        alreadySend: 'Reinvia codice',
        search: 'Ricerca',
        region: 'Regione',
        emptyPhone: 'Numero di cellulare',
        getCodeFirst: 'Invia prima il codice.',
        loginTryMany: "Troppi tentativi, l'account è stato bloccato. Per favore riprova più tardi.",
        know: 'OK',
        chooseLang: 'Lingue',
        second: 's',
        useNotFound: "L'utente richiesto NON esiste.",
        phoneNotFound: "L'utente richiesto NON esiste.",
        notMatch: 'Password non valida',
        errorMuch: 'Troppi tentativi, riprova più tardi.',
        codeErr: 'Il codice di verifica non è valido o è scaduto.',
        codeSendErr: 'Impossibile inviarti un codice.',
        codeSendFrequent: 'Troppi tentativi, riprova più tardi...',
        codeSendLimit: 'Numero superato di richieste di codici di verifica. Riprova tra 2 ore.',
        sendSuccess: "Ti è stato inviato un codice.",
        sendFailure: "Impossibile inviarti un codice.",
        unregisterPhone: "Questo account non esiste. Per favore registrati nell'APP MOVAhome."
    },
    "pl": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'Zaloguj się do MOVAhome App',
        phoneEmailId: "Numer telefonu/e-mail/MOVA ID",
        validPhoneEmailId: 'Numer telefonu/e-mail/MOVA ID',
        password: 'Hasło',
        validPassword: 'Hasło',
        codeLogin: 'Zaloguj się za pomocą kodu weryfikacyjnego',
        phoneNumber: 'Numer telefonu',
        validPhoneNumer: 'Numer telefonu',
        validCode: 'Kod weryfikacyjny',
        code: 'Kod weryfikacyjny',
        accountPasswordLogin: 'Zaloguj się za pomocą hasła',
        pleaseCheck: 'Przeczytałem i zgadzam się z warunkami ',
        userShedule: 'Regulaminu Użytkownika',
        and: 'i',
        privary: "Polityki Prywatności",
        addtionnal: "",
        login: 'Zaloguj',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Logując się, upoważniasz',
        loginDescPart12: 'do sterowania swoimi urządzeniami.',
        getCode: 'Odbierz kod',
        alreadySend: 'Wyślij kod ponownie',
        search: 'Wyszukaj',
        region: 'Region',
        emptyPhone: 'Numer telefonu',
        getCodeFirst: 'Należy najpierw pozyskać kod weryfikacyjny.',
        loginTryMany: 'Podjęto zbyt wiele prób, konto zostało zablokowane. Spróbuj ponownie później.',
        know: 'Rozumiem',
        chooseLang: 'Języki',
        second: 's',
        useNotFound: 'Użytkownik nie istnieje.',
        phoneNotFound: 'Użytkownik nie istnieje.',
        notMatch: 'Niepoprawne hasło',
        errorMuch: 'Wykonano zbyt wiele prób. Spróbuj ponownie później.',
        codeErr: 'Kod weryfikacyjny jest niepoprawny lub wygasł.',
        codeSendErr: 'Nie udało się wysłać kodu.',
        codeSendFrequent: 'Wykonano zbyt wiele prób. Proszę spróbować później…',
        codeSendLimit: 'Przekroczono liczbę żądań kodu weryfikacyjnego. Proszę spróbować ponownie za 2 godziny.',
        sendSuccess: "Kod został do Ciebie wysłany.",
        sendFailure: "Nie udało się wysłać kodu.",
        unregisterPhone: "To konto nie istnieje. Proszę zarejestrować się w aplikacji MOVAhome APP."
    },
    "tr": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'MOVAhome Uygulamasında oturum açın',
        phoneEmailId: "Cep telefonu numarası/e-posta/MOVA ID",
        validPhoneEmailId: 'Cep telefonu numarası/e-posta/MOVA ID',
        password: 'Şifre',
        validPassword: 'Şifre',
        codeLogin: 'Doğrulama koduyla giriş yapın',
        phoneNumber: 'Cep numarası',
        validPhoneNumer: 'Cep numarası',
        validCode: 'Doğrulama kodu',
        code: 'Doğrulama kodu',
        accountPasswordLogin: 'Şifre ile giriş yapın',
        pleaseCheck: '',
        userShedule: 'Kullanıcı Sözleşmesini',
        and: 've',
        privary: "Gizlilik Politikasını",
        addtionnal: "okudum ve kabul ediyorum.",
        login: 'Giriş',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Giriş yaparak',
        loginDescPart12: 'e cihazlarınızı kontrol etme yetkisi veriyorsunuz.',
        getCode: 'Kod al',
        alreadySend: '已发送',
        search: 'Ara',
        region: 'Bölge',
        emptyPhone: 'Cep numarası',
        getCodeFirst: 'Lütfen önce kodun gönderilmesini sağlayın.',
        loginTryMany: 'Yanlış şifre sayısı sınıra ulaştı, hesap kilitlendi, lütfen daha sonra tekrar deneyin.',
        know: 'Tamam',
        chooseLang: 'Diller',
        second: 's',
        useNotFound: 'İstenen kullanıcı mevcut DEĞİL.',
        phoneNotFound: 'İstenen kullanıcı mevcut DEĞİL.',
        notMatch: 'Geçersiz şifre',
        errorMuch: 'Çok fazla denendi. Lütfen daha sonra tekrar deneyiniz.',
        codeErr: 'Doğrulama kodu geçersiz veya süresi dolmuş.',
        codeSendErr: 'Size kod gönderilemedi.',
        codeSendFrequent: 'Çok fazla denendi. Lütfen daha sonra tekrar deneyiniz...',
        codeSendLimit: 'Doğrulama kodu isteği sayısı aşıldı. Lütfen 2 saat sonra tekrar deneyin.',
        sendSuccess: "Size bir kod gönderildi.",
        sendFailure: "Size kod gönderilemedi.",
        unregisterPhone: "Bu hesap mevcut değil. Lütfen MOVAhome APP'ye kaydolun."
    },
    "vi": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'Đăng nhập vào Ứng Dụng MOVAhome',
        phoneEmailId: "Số điện thoại/email/MOVA ID",
        validPhoneEmailId: 'Số điện thoại/email/MOVA ID',
        password: 'Mật khẩu',
        validPassword: 'Mật khẩu',
        codeLogin: 'Đăng nhập bằng mã xác thực',
        phoneNumber: 'Số điện thoại',
        validPhoneNumer: 'Số điện thoại',
        validCode: 'Mã xác thực',
        code: 'Mã xác thực',
        accountPasswordLogin: 'Đăng nhập bằng mật khẩu',
        pleaseCheck: 'Tôi đã đọc và đồng ý với',
        userShedule: 'Thỏa Thuận Người Dùng',
        and: 'và',
        privary: "Chính Sách Quyền Riêng Tư.",
        addtionnal: "",
        login: 'Đăng nhập',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Bằng việc đăng nhập, bạn cho phép',
        loginDescPart12: 'kiểm soát thiết bị của mình.',
        getCode: 'Lấy mã',
        alreadySend: '已发送',
        search: 'Tìm kiếm',
        region: 'Khu vực',
        emptyPhone: 'Số điện thoại',
        getCodeFirst: 'Vui lòng nhận mã trước.',
        loginTryMany: 'Đã thử quá nhiều lần, tài khoản đã bị khóa. Vui lòng thử lại sau.',
        know: 'OK',
        chooseLang: 'Ngôn ngữ',
        second: 's',
        useNotFound: 'Người dùng được yêu cầu KHÔNG tồn tại.',
        phoneNotFound: 'Người dùng được yêu cầu KHÔNG tồn tại.',
        notMatch: 'Mật khẩu không hợp lệ',
        errorMuch: 'Đã thử quá nhiều lần, vui lòng thử lại sau.',
        codeErr: 'Mã xác thực không hợp lệ hoặc đã hết hạn.',
        codeSendErr: 'Không thể gửi mã đến bạn.',
        codeSendFrequent: 'Đã thử quá nhiều lần, vui lòng thử lại sau …',
        codeSendLimit: 'Đã vượt số lần yêu cầu mã xác thực. Vui lòng thử lại trong 2 giờ.',
        sendSuccess: "Một mã đã được gửi đến bạn.",
        sendFailure: "Không thể gửi mã đến bạn.",
        unregisterPhone: "Tài khoản này không tồn tại. Vui lòng đăng ký trong Ứng Dụng MOVAhome"
    },
    "th": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'เข้าสู่ระบบของ MOVAhome App',
        phoneEmailId: "หมายเลขมือถือ/อีเมล/MOVA ID",
        validPhoneEmailId: 'หมายเลขมือถือ/อีเมล/MOVA ID',
        password: 'รหัสผ่าน',
        validPassword: 'รหัสผ่าน',
        codeLogin: 'เข้าสู่ระบบด้วยรหัสยืนยัน',
        phoneNumber: 'หมายเลขมือถือ',
        validPhoneNumer: 'หมายเลขมือถือ',
        validCode: 'รหัสยืนยัน',
        code: 'รหัสยืนยัน',
        accountPasswordLogin: 'เข้าสู่ระบบด้วยรหัสผ่าน',
        pleaseCheck: 'ฉันได้อ่านและยอมรับ',
        userShedule: 'ข้อตกลงผู้ใช้',
        and: 'กับ',
        privary: "นโยบายความเป็นส่วนตัว",
        addtionnal: "",
        login: 'เข้าสู่ระบบ',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'การเข้าสู่ระบบของเรา แสดงว่าคุณอนุญาตให้',
        loginDescPart12: 'ควบคุมอุปกรณ์ของคุณ',
        getCode: 'รับรหัส',
        alreadySend: '已发送',
        search: 'ค้นหา',
        region: 'ภูมิภาค',
        emptyPhone: 'หมายเลขมือถือ',
        getCodeFirst: 'กรุณารับรหัสยืนยันก่อน',
        loginTryMany: 'ลองหลายครั้งเกินไป บัญชีถูกล็อค โปรดลองอีกครั้งในภายหลัง',
        know: 'ตกลง',
        chooseLang: 'ภาษา',
        second: 's',
        useNotFound: 'ไม่พบชื่อผู้ใช้นี้',
        phoneNotFound: 'ไม่พบชื่อผู้ใช้นี้',
        notMatch: 'รหัสผ่านไม่ถูกต้อง',
        errorMuch: 'ลองบ่อยครั้งเกินไป กรุณาลองอีกครั้งในภายหลัง',
        codeErr: 'รหัสยืนยันไม่ถูกต้องหรือหมดอายุ',
        codeSendErr: 'ส่งรหัสล้มเหลว',
        codeSendFrequent: 'กดส่งบ่อยเกินไป กรุณาลองอีกครั้งในภายหลัง...',
        codeSendLimit: 'ขอรหัสยืนยันเกินจำนวนครั้งที่จำกัด กรุณารอ 2 ชั่วโมงและลองอีกครั้ง',
        sendSuccess: "ส่งรหัสเรียบร้อย",
        sendFailure: "ส่งรหัสล้มเหลว",
        unregisterPhone: "ไม่พบบัญชีนี้ โปรดลงทะเบียนในแอป MOVAhome"
    },
    "id": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'Log in Aplikasi MOVAhome',
        phoneEmailId: "Nomor ponsel/email/ID MOVA",
        validPhoneEmailId: 'Nomor ponsel/email/ID MOVA',
        password: 'Kata sandi',
        validPassword: 'Kata sandi',
        codeLogin: 'Login dengan kode verifikasi',
        phoneNumber: 'Nomor ponsel',
        validPhoneNumer: 'Nomor ponsel',
        validCode: 'Kode verifikasi',
        code: 'Kode verifikasi',
        accountPasswordLogin: 'Login dengan kata sandi',
        pleaseCheck: 'Saya telah membaca dan menyetujui',
        userShedule: 'Perjanjian Pengguna',
        and: 'dan',
        privary: "Kebijakan Privasi.",
        addtionnal: "",
        login: 'Log In',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Dengan log in, Anda telah mengizinkan',
        loginDescPart12: 'untuk mengontrol perangkat Anda.',
        getCode: 'Dapatkan kode',
        alreadySend: '已发送',
        search: 'Mencari',
        region: 'Wilayah',
        emptyPhone: 'Nomor ponsel',
        getCodeFirst: 'Silakan dapatkan kode verifikasi terlebih dahulu.',
        loginTryMany: 'Terlalu banyak mencoba, akun telah dikunci. Silakan coba sesaat lagi.',
        know: 'OK',
        chooseLang: 'Bahasa',
        second: 's',
        useNotFound: 'Akun pengguna ini TIDAK ada.',
        phoneNotFound: 'Akun pengguna ini TIDAK ada.',
        notMatch: 'Kata sandi salah',
        errorMuch: 'Terlalu banyak percobaan, coba sesaat lagi.',
        codeErr: 'Kode verifikasi tidak valid atau kedaluwarsa.',
        codeSendErr: 'Kode gagal terkirim.',
        codeSendFrequent: 'Terlalu banyak percobaan, coba sesaat lagi…',
        codeSendLimit: 'Melampaui batas maksimum permintaan kode verifikasi. Silakan tunggu 2 jam dan coba lagi.',
        sendSuccess: "Kode sukses terkirim.",
        sendFailure: "Kode gagal terkirim.",
        unregisterPhone: "Akun ini tidak ada. Silakan mendaftar di Aplikasi MOVAhome."
    },
    "uk": {
        leelen:'Leelen',
        vk: 'VK',
        moorgen: 'Moorgen',
        title: 'Увійти до додатку MOVAhome',
        phoneEmailId: "Номер мобільного телефону/електронна пошта/MOVA ID",
        validPhoneEmailId: 'Номер мобільного телефону/електронна пошта/MOVA ID',
        password: 'Пароль',
        validPassword: 'Пароль',
        codeLogin: 'Увійдіть за допомогою коду підтвердження',
        phoneNumber: 'Номер мобільного телефону',
        validPhoneNumer: 'Номер мобільного телефону',
        validCode: 'Код підтвердження',
        code: 'Код підтвердження',
        accountPasswordLogin: 'Увійдіть за допомогою пароля',
        pleaseCheck: 'Я прочитав і погодився з',
        userShedule: 'Угодою користувача',
        and: 'та',
        privary: "Політикою конфіденційності.",
        addtionnal: "",
        login: 'Увійти',
        google: 'google',
        Alexa: 'Amazon Alexa',
        hornbach: 'Hornbach',
        xiaodu: 'Baidu DuerOS',
        cat: 'Aligenie',
        Alice: 'Yandex Alice',
        loginDescPart1: 'Входячи до системи, ви надаєте дозвіл',
        loginDescPart12: 'на управління вашими пристроями.',
        getCode: 'Отримати код',
        alreadySend: '已发送',
        search: 'Пошук',
        region: 'Регіон',
        emptyPhone: 'Номер мобільного телефону',
        getCodeFirst: 'Будь ласка, спочатку надішліть код.',
        loginTryMany: 'Забагато спроб, обліковий запис заблоковано. Будь ласка, спробуйте пізніше.',
        know: 'ОК',
        chooseLang: 'Мови',
        second: 's',
        useNotFound: 'Користувач, запит якого відбувається, НЕ існує.',
        phoneNotFound: 'Користувач, запит якого відбувається, НЕ існує.',
        notMatch: 'Недійсний пароль',
        errorMuch: 'Забагато спроб, будь ласка, спробуйте пізніше.',
        codeErr: 'Код підтвердження недійсний або термін його дії збіг.',
        codeSendErr: 'Не вдалося надіслати код.',
        codeSendFrequent: 'Забагато спроб, будь ласка, спробуйте пізніше...',
        codeSendLimit: 'Перевищено кількість запитів коду підтвердження. Повторіть спробу через 2 години.',
        sendSuccess: "Вам надіслано код.",
        sendFailure: "Не вдалося надіслати код.",
        unregisterPhone: "Цей обліковий запис не існує. Будь ласка, зареєструйтеся в додатку MOVAhome."
    },
}